import {Box, SvgIcon} from "@mui/material";
import React from "react";

export default function DecoyIcon(props) {
  return(
      <img src="/Icons/decoy.svg" alt="decoy" {...props}/>
  )
}